<template>
    <div class="attributes-container scroll">
        <section v-for="attribute in attributes" :key="attribute.id">
            <div class="attribute-content">
                <div class="col-6 attribute-title">
                    <span>{{ attribute.name }}</span>
                </div>
                <div class="col-6 attribute-menu">
                    <MenuAttributeCompact :attribute="attribute" />
                    <apexchart
                        :style="attribute.horizon_one_page_id != null && 'margin-left: .5rem'"
                        class="apexchart"
                        height="100"
                        :series="performanceProgress(attribute.performance.progress)"
                        :options="updateColors(attribute.performance.progress)"
                    />
                </div>
            </div>
            <div class="divider"></div>
        </section>
    </div>
</template>

<script>
import MenuAttributeCompact from './MenuAttributeCompact.vue'
export default {
    name: 'AttributeCard',
    components: {
        MenuAttributeCompact,
    },
    props: {
        attributes: {
            type: Array,
        },
    },
    methods: {
        performanceProgress(progress) {
            return [(progress * 100).toFixed(0)]
        },
        updateColors(progress) {
            let value = (progress * 100).toFixed(0)
            if (value == 0) {
                return this.updateColor('#999')
            } else if (value > 0 && value < 30) {
                return this.updateColor('#f05050')
            } else if (value >= 30 && value < 70) {
                return this.updateColor('#fad732')
            } else {
                return this.updateColor('#27c24c')
            }
        },
        updateColor(newColor) {
            return {
                colors: [newColor],
                chart: {
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 0,
                            size: '45%',
                        },
                        track: {
                            background: '#FFF',
                            strokeWidth: '70%',
                            margin: 3,
                            dropShadow: {
                                enabled: true,
                                top: 0,
                                left: 0,
                                color: newColor,
                                blur: 0,
                            },
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                show: true,
                                offsetY: 5,
                                fontSize: '14px',
                                color: newColor,
                            },
                        },
                    },
                },
                labels: ['Progress'],
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                        },
                    },
                    hover: {
                        filter: {
                            type: 'none',
                        },
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'none',
                        },
                    },
                },
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.attributes-container
    display: flex
    flex-direction: column
    max-height: 400px
    overflow: auto
    .attribute-content
        min-height: 70px
        width: 100%
        background: #F9F9F9
        border-radius: 10px
        display: flex
        align-items: center
        .attribute-title
            color: #3B3F4E
            font-size: 1rem
            padding: .5rem 0 .5rem .5rem
        .attribute-menu
            display: flex
            justify-content: flex-end
            align-items: center
            .apexchart
                width: 60px
    .divider
        margin: 1rem 0
        border-bottom: 1px solid #6E6E6E
        opacity: .2
</style>
